import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpLight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 48,
	viewBox: "0 0 64 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M35.9854 47C31.9708 41.3146 26.0167 25.031 29.9634 27.8764C34.9817 31.4944 40 40.1828 40 36.1461C40 32.0112 25.447 1 24.4433 1M24.4433 1C23.6404 1 24.1088 9.26966 24.4433 13.4045M24.4433 1C28.458 2.03371 34.8814 9.37303 34.4799 9.78652",
		stroke: "currentColor",
		strokeOpacity: .32,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgArrowUpLight;
